export enum VehicleIssueStatusenum {
  OPEN = "OPEN",
  IN_PROGRESS = "IN PROGRESS",
  PENDING = "PENDING",
  RESOLVED = "RESOLVED",
  REJECTED = "REJECTED",
}
